import { jsxs, jsx } from 'react/jsx-runtime';
import { motion } from 'framer-motion';
import styled from 'styled-components';

const StyledCircle = styled.circle.withConfig({
  componentId: "sc-w9vxhg-0"
})(["fill:", ";"], ({
  theme
}) => theme.components.emptyState.illustrations.success.backgroundColor);
const StyledCheckmarkCircle = styled(motion.circle).withConfig({
  componentId: "sc-w9vxhg-1"
})(["fill:", ";"], ({
  theme
}) => theme.components.emptyState.illustrations.success.checkmarkColor);
const StyledForegroundCircle = styled(motion.circle).withConfig({
  componentId: "sc-w9vxhg-2"
})(["fill:", ";"], ({
  theme
}) => theme.components.emptyState.illustrations.success.foregroundColor);
function Success() {
  return jsxs("svg", {
    fill: "none",
    height: "160",
    viewBox: "0 0 160 160",
    width: "160",
    xmlns: "http://www.w3.org/2000/svg",
    children: [jsx("title", {
      children: "Animated checkmark in green circle."
    }), jsx(StyledCircle, {
      cx: "80",
      cy: "80",
      r: "62"
    }), jsxs("mask", {
      id: "checkMask",
      children: [jsx("rect", {
        fill: "black",
        height: "160",
        width: "160",
        x: "0",
        y: "0"
      }), jsx(StyledCheckmarkCircle, {
        animate: {
          r: 62
        },
        cx: "80",
        cy: "80",
        r: "0",
        transition: {
          delay: 0.7
        }
      })]
    }), jsx(StyledForegroundCircle, {
      animate: {
        r: 62
      },
      cx: "80",
      cy: "80",
      r: "0",
      transition: {
        delay: 0.4
      }
    }), jsx("path", {
      d: "M72.1074 99.8456L107 64.953L101.047 59L72.1074 87.9396L58.953 74.7853L53 80.7382L72.1074 99.8456Z",
      fill: "white",
      mask: "url(#checkMask)"
    })]
  });
}

export { Success as default };
//# sourceMappingURL=Success.js.map
